export const handleEnquiry = (product) => {
  let message = `Hi, I am enquiring from Orion Cells Website. I want to purchase ${product.name} `
  let phone = '919605002323'; // Assuming the phone number is in the format "1234567890"
  let url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
}